import { render, staticRenderFns } from "./decoration4.vue?vue&type=template&id=308fb656&scoped=true"
import script from "./decoration4.vue?vue&type=script&lang=js"
export * from "./decoration4.vue?vue&type=script&lang=js"
import style0 from "./decoration4.vue?vue&type=style&index=0&id=308fb656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308fb656",
  null
  
)

export default component.exports